import { createSlice }          from '@reduxjs/toolkit';
import ChatSessionService       from 'services/chat-session.service';
import AuthService              from 'services/auth.service';

export const teleconsultSlice = createSlice({
  name: 'theTeleconsult',
  initialState: {
    unread_count: 0,
    unread_sessions: []
  },
  reducers: {
    removeUnreads: (state, action) => {
      let newUnreads = state.unread_sessions.filter(function( obj ) {
        return obj.twilio_sid !== action.payload;
      });
      state.unread_count = newUnreads.length;
      state.unread_sessions = newUnreads;
    },
    getUnreadsSuccess: (state, {payload}) => {
      state.unread_sessions = payload.chat_sessions
      state.unread_count = payload.chat_sessions.length
    },
  },
})

// Action creators are generated for each case reducer function
export const { removeUnreads, getUnreadsSuccess } = teleconsultSlice.actions
export const teleconsultSelector = state => state.theTeleconsult

export default teleconsultSlice.reducer

// Asynchronous thunk action
export function fetchUnreads() {
  return async dispatch => {

  ChatSessionService.getUnreadCounts().then(
    (data) => {
      dispatch(getUnreadsSuccess(data))
    },
    (error) => {
      if (error.response.status === 401) {
        AuthService.logout();
        window.location.replace('/eb/login');
      }
    });
  }
}